import type { TypeFormFieldElement } from '../../../types/form';

import getValidationName from './getValidationName';

// ----------------------------------------------------------------------------

type TypeShouldValidateFieldData = {
    exceptedFields?: string[];
    excludeTypes?: string[];
};

// ----------------------------------------------------------------------------

function shouldValidateField(
    field: TypeFormFieldElement,
    data: TypeShouldValidateFieldData = {},
    validationName: string = getValidationName(field),
): boolean {
    if (validationName.length === 0 || field.disabled) {
        return false;
    }

    if (data.exceptedFields?.includes(validationName)) {
        return false;
    }

    if (field instanceof HTMLInputElement && data.excludeTypes?.includes(field.type)) {
        return false;
    }

    return true;
}

// ----------------------------------------------------------------------------

export default shouldValidateField;
